<template>
	<div class="layout-footer">
		<span class="footer-text" style="margin-right: 5px">&copy;</span>
		<span class="footer-text" style="margin-left: 5px">De Tafelheer</span>
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>

</style>
